import { User, UserGroup, UserPermission } from 'users/interfaces/user.interface';
import { VisualPermissionResponse } from 'users/interfaces/visual-permissions.interface';

export interface ResourcePermission {
    id: string;
    resourceId: string;
    accessType: 'READ' | 'EDIT' | 'CREATE' | 'DELETE' | 'PUBLISH';
    userId: string;
    userGroupId: string;
    createdAt: string;
    modifiedAt: string;
    createdBy: string;
    modifiedBy: string;
    userGroup: UserGroup;
    user: User;
}

export interface UserGroupPermission {
    id: string;
    userGroupId: string;
    userGroup: UserGroup;
    permissionAccessZone: PermissionAccessZoneEnum;
    permissionOwner: User | UserGroup;
    accessType: AccessTypeEnum;
    createdAt: string;
    modifiedAt: string;
    createdBy: string;
    modifiedBy: string;
}

export enum PermissionAccessZoneEnum {
    ACCESS_TO_USERS = 'ACCESS_TO_USERS',
    ACCESS_TO_USER_GROUPS = 'ACCESS_TO_USER_GROUPS',
    ACCESS_TO_LISTINGS_ACCESS_GROUPS = 'ACCESS_TO_LISTINGS_ACCESS_GROUPS',
    ACCESS_TO_BULK_OPERATIONS = 'ACCESS_TO_BULK_OPERATIONS',
    ACCESS_TO_CHANNEL_SNAPSHOT_REGENERATION = 'ACCESS_TO_CHANNEL_SNAPSHOT_REGENERATION',
}

export enum AccessTypeEnum {
    READ = 'READ',
    EDIT = 'EDIT',
    INVITE = 'INVITE',
}

export enum OutletDistributionPermissionEnum {
    READ = 'READ',
    EDIT = 'EDIT',
    NONE = 'NONE',
}

export type ApplicationPermissionArray = [
    Partial<ResourcePermission>[],
    Partial<UserGroupPermission | UserPermission>[],
    VisualPermissionResponse[],
];

export enum ShijiPermissionsEnum {
    SHIJI_PERMISSION = 'SHIJI_PERMISSION',
    SUPPLIER_DELETION = 'SUPPLIER_DELETION',
    CUSTOM_FIELDS = 'CUSTOM_FIELDS',
    BACKDOOR_PASSWORD = 'BACKDOOR_PASSWORD',
    BULK_OPERATIONS = 'BULK_OPERATIONS',
}

export interface PermissionJSON {
    type: 'internal' | 'resource' | 'admin';
    name?: PermissionAccessZoneEnum | PermissionAccessZoneEnum[];
    minLevel?: AccessLevel;
    maxLevel?: AccessLevel;
    resourceName?:
        | 'listings'
        | 'listingProfile'
        | 'conferenceEvent'
        | 'distribution'
        | 'entertainment'
        | 'listingDetails'
        | 'foodAndBeverage'
        | 'healthAndWellness'
        | 'location'
        | 'outlet'
        | 'policy'
        | 'ratePlan'
        | 'recreation'
        | 'roomType'
        | 'safety'
        | 'shopping'
        | 'visuals'
        | 'customFields';
    requiresSpecialAdminPermission?: ShijiPermissionsEnum;
    allowAnyAdmin?: boolean;
    applicableToSupplierUsersOnly?: boolean;
    allowWildcardRoutes?: boolean;
}

export interface PermissionJSONLevel {
    [key: string]: PermissionObject | PermissionJSONLevel;
}

export type PermissionObject = PermissionJSON | PermissionJSON[] | [PermissionJSON[]];

export type AccessLevel = 'read' | 'edit' | 'create' | 'invite' | 'delete' | 'publish' | 'allow';

export function isPermissionJSON(obj: PermissionObject): obj is PermissionJSON {
    return !Array.isArray(obj) && 'type' in obj;
}
